/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

// style
import { DamIcon } from '../../../assets/svg/Icon';
import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function DamList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, handleDetailList, handleOpenLegend, mobilemode,
  } = props;

  const [damYellow, setDamYellow] = useState([]);

  const filterDamsByLowerRuleCurve = async (damDataList) => {
    const currentYear = new Date().getFullYear();
    const filteredResults = [];

    for (const dam of damDataList) {
      try {
        const damId = dam?.dam?.id;
        const damDateStr = dam?.dam_date;
        const damStorage = dam?.dam_storage;

        if (!damId || !damDateStr || damStorage === undefined) {
          console.error('ข้อมูลไม่ครบ:', dam);
          continue;
        }

        const apiUrl = `${process.env.REACT_APP_API_URL}/analyst/dam_yearly_graph?data_type=dam_storage&dam_id=${damId}&year=${currentYear}`;
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const apiData = await response.json();

        const lowerRuleCurve = apiData?.data?.lower_rule_curve;

        if (!lowerRuleCurve || lowerRuleCurve.length === 0) continue;

        const targetMonthDay = damDateStr.slice(5);
        const ruleForDay = lowerRuleCurve.find((rule) => rule.date.slice(5) === targetMonthDay);
        if (ruleForDay && damStorage < ruleForDay.value) {
          filteredResults.push(dam);
        }
      } catch (error) {
        console.error(`หา dam_id: ${dam?.dam?.id}`, error);
      }
    }
    return filteredResults;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (datas?.yellow) {
        const result = await filterDamsByLowerRuleCurve(datas.yellow);
        setDamYellow(result);
      }
    };
    fetchData();
  }, [datas]);

  return (
    <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewDam}>
      <Box display="flex" justifyContent="flex-start">
        <Box>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              {!isEmpty(datas)
                ? (
                  <IconButton onClick={mobilemode ? null : handleDetailList(datas)}>
                    <StyledBadge
                      id="dam_detail"
                      badgeContent={datas !== undefined ? datas.count : ''}
                      overlap="circular"
                      color="secondary"
                    >
                      <DamIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  </IconButton>
                ) : (
                  <StyledBadge
                    id="dam_detail"
                    badgeContent={datas !== undefined ? datas.count : ''}
                    overlap="circular"
                    color="secondary"
                  >
                    <DamIcon style={{ color: 'white' }} />
                  </StyledBadge>
                )}
            </Box>
            <Box id="dialog_dam" display="flex" alignItems="center">
              <Box pl={1}>
                <IconButton id="legend_dam" className={classes.btn} onClick={handleOpenLegend(t('เกณฑ์แหล่งน้ำ'), 'dam')}>
                  <InfoIcon type="button" style={{ fontSize: 13, color: '#777' }} />
                </IconButton>
              </Box>
              <Box p={1}>
                <Link id="navigate_dam" to={`${initPath}dam`}>
                  <Typography className={classes.titleBox}>
                    {t('แหล่งน้ำ')}
                  </Typography>
                </Link>
              </Box>
              <Box>
                <Typography className={classes.timeBox}>
                  {datas.time}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            className={`${classes.listsBox}`}
          >
            {datas.yellow !== undefined
              && (
                <Grid id="dialog_dam_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                  {datas.yellow.length > 0
                    && (
                      <>
                        <span style={{ color: '#F89408' }}>
                          <strong>
                            {t('น้ำน้อยวิกฤต (%น้ำใช้การ)')}
                            {' '}
                            :
                          </strong>
                        </span>

                        {orderBy(damYellow, 'dam_uses_water_percent')
                          .map((d) => (
                            <Grid item key={d.id} style={{ color: '#000' }}>
                              <strong>
                                {`${d.dam.dam_name.th} (${d.dam_uses_water_percent.toFixed(0)}%)`}
                              </strong>
                            </Grid>
                          ))}
                      </>
                    )}

                  <Box width="100%" />
                  {datas.red.length > 0
                    && (
                      <>
                        <span style={{ color: '#FF0000' }} justify="flex-start">
                          <strong>
                            {t('น้ำมากวิกฤต (%ความจุ)')}
                            {' '}
                            :
                          </strong>
                        </span>

                        {orderBy(datas.red, 'dam_storage_percent', 'desc')
                          .map((d) => (
                            <Grid item key={d.id} style={{ color: '#000' }}>
                              <strong>
                                {`${d.dam.dam_name.th} (${d.dam_storage_percent.toFixed(0)}%)`}
                              </strong>
                            </Grid>
                          ))}
                      </>
                    )}

                  {(datas.yellow.length <= 0 && datas.red.length <= 0)
                    && (
                      <Grid item>
                        <Box
                          className={`${classes.listsBox}`}
                          style={{ backgroundColor: '#FFFFFF90', fontWeight: 'bold', color: '#000' }}
                        >
                          {t('ปกติ')}
                        </Box>
                      </Grid>
                    )}
                </Grid>
              )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

DamList.defaultProps = {
  mobilemode: false,
};

DamList.propTypes = {
  datas: PropTypes.objectOf(Object).isRequired,
  handleDetailList: PropTypes.func.isRequired,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
